<script setup lang="ts">
/**
 * SeoFinalCta — the closing call-to-action of an SEO page on a raised paper sheet.
 * With `cat`, her `peek_cat` looks in from the sheet's bottom-right corner (a cropped
 * drawing: both cut edges run past the sheet's edges, as PeekNote / the /spread tiles).
 * Static (no motion); the cut-out loads lazily — it's always below the fold.
 */
import PaperCutout from '@app/presentation/components/paper/PaperCutout.vue';

defineProps<{ cat?: boolean }>();
</script>

<template>
  <section class="relative mx-auto w-full max-w-[880px]">
    <div
      class="paper-sheet-raised relative overflow-hidden px-6 py-9 text-center md:px-12 md:py-12"
      :class="cat && 'pb-32 md:pb-12'"
    >
      <div
        v-if="cat"
        class="pointer-events-none absolute -bottom-2 -right-2 w-[128px] md:w-[160px]"
        aria-hidden="true"
      >
        <PaperCutout
          name="peek_cat"
          still
          lazy
        />
      </div>
      <div class="relative z-[1]">
        <slot />
      </div>
    </div>
  </section>
</template>
